import React from 'react';

export default function useDialog(): [boolean, () => void, () => void] {
	const [shown, setShown] = React.useState(false);
	const show = () => {
		setShown(true);
	};
	const hide = () => {
		setShown(false);
	};

	return [shown, show, hide];
}
